import { createSelector } from "@ngrx/store";
import { IFuncionarioState } from "./funcionario.reducer";

const funcionarioStore = (state: any) => state.funcionario as IFuncionarioState;

export const selectFuncionarioLista = createSelector(
  funcionarioStore,
  (state) => state.lista
);

export const selectFuncionarioState = createSelector(
  funcionarioStore,
  (state) => ({type: state.type, action: state.action})
);
